import React, { useEffect } from 'react'
import { Add_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// =================================================================
export const AddObjectInstanceComponent = ({ objectTypeId, setLoading, showMessage, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm();
    // =================================================================
    useEffect(() => {
        form.setFieldsValue({ isActive: true });
    }, []);
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            values.objectTypeId = objectTypeId;
            let data = await Add_ObjectInstance_Api(values);
            setLoading(false);
            rowInserted();
            if (data.messageStatus == "Successful")
                showMessage(data.message, "Successful")
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    اضافه کردن موجودیت جدید
                </h2>
            </div>
            <div className='container'>

                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>

                    <Form.Item
                        name="capacity"
                        label="ظرفیت"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='ظرفیت' />
                    </Form.Item>

                    <Form.Item
                        name="capacityFrom"
                        label="حداقل ظرفیت"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='حداقل ظرفیت' />
                    </Form.Item>

                    <Form.Item
                        name="capacityTo"
                        label="حداکثر ظرفیت"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='حداکثر ظرفیت' />
                    </Form.Item>

                    <Form.Item
                        name="isMenGroup"
                        valuePropName='checked'
                        label="مجردی مردانه"
                    >
                        <Checkbox></Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="isWomanGroup"
                        valuePropName='checked'
                        label="مجردی زنانه"
                    >
                        <Checkbox ></Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="orderIndex"
                        label="ترتیب"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="isActive"
                        label="فعال"
                        valuePropName='checked'
                    >
                        <Checkbox ></Checkbox>
                    </Form.Item>
                </Form>
            </div>

            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <RollbackOutlined />
                        لغو </Button>
                </Col>
            </Row>
        </>
    )
}